import React from "react";

export const LogoTrustAuto = (props) => (
  
  <div
    style={{
      display: "flex",
      padding: 16,
      cursor: "pointer",
    }}
  >
  </div>
);

export default LogoTrustAuto;
